export default __webpack_public_path__ + "images/marker-icon.7126f7210a78a5cd5f656a5b3f2e570a.png";